import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  AlertColor,
  Chip,
  FormHelperText,
  FormLabel,
  Icon,
  InputAdornment,
  Paper,
} from "@mui/material";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import CustomerBrandingModal, {
  DEFAULT_BRANDING_VALUES,
  IBrandingForm,
  IPendingBrandingAction,
} from "./CustomerBrandingModal";
import { useCommonDetailsContext } from "../../context/Common/common";
import Grid from "@mui/material/Unstable_Grid2";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { TrackNowTextField, TrackNowButton, TrackNowSelect } from "../ui";
import { TrackNowRadio } from "../ui/TrackNowRadio";
import { Button } from "primereact/button";
import Autocomplete from "@mui/material/Autocomplete";
import LoadingButton from "@mui/lab/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress";
import Select, { type SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useAppTheme from "../../theme/theme";
import { Stack } from "@mui/material";
import AuthContext from "../../context/auth/AuthContext";
import CustomerContext from "../../context/customer/CustomerContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import { Customer } from "../../types/customer";
import states from "../../data/StateLookup.json";
import { BusinessCategory } from "../../types/FilingMaster";
import { ProgramName } from "../../types/FilingMaster";
import MultiSelect from "../common/MultiSelect";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomDialog from "../common/CustomDialog";
import { useFormik } from "formik";
import * as yup from "yup";
import _ from "lodash";
import axios from "axios";
import Loader from "../common/Loader";
import Alert from "@mui/material/Alert";
import { tokens } from "../../theme/tokens";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";


// import { transform } from "lodash";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import { Toast } from "primereact/toast";
// import AddressForm from "./AddressForm";
// import PaymentForm from "./PaymentForm";
// import Review from "./Review";
// const categories = [
// { id: 1, category: "Telecom" },
// { id: 2, category: "Brodband" },
// { id: 3, category: "Wireless" },
// { id: 4, category: "Mobile" },
// ];
// function Copyright() {

// return (
// <Typography variant='body2' color='text.secondary' align='center'>
// {"Copyright © "}
// <Link color='inherit' href='https://mui.com/'>
// Your Website
// </Link>{" "}
// {new Date().getFullYear()}
// {"."}
// </Typography>
// );
// }

// const handleClickOpenServiceArea = () => {
// console.log("##Project:", projectObj.ID);
// if (projectObj.ID) setOpenServiceArea(true);
// else {
// setShowAlertMessage({
// message: "Please create the project prior to configuring Service Areas",
// title: "Info",
// handleClose: { handleCloseAlert },
// });
// setShowAlert(true);
// }
interface IClient {
  customerId: number;
  label: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const validationSchema = yup.object({
  customerName: yup
    .string()
    .min(2, "Name is too Short!")
    .max(100, "Name is too Long!")
    .required("Client Name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .max(60, "Email cannot exceed 60 characters")
    .matches(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/i,
      "Enter a valid email"
    ),
  city: yup
    .string()
    .max(100, "City cannot exceed 100 characters"),
  address: yup
    .string()
    .max(200, "Address cannot exceed 200 characters"),
  phone: yup
    .string()
    .test("phone", "Enter a valid phone number", (value) => {
      if (!value) return true; // Optional field

      const regex = /^\(([2-9]\d{2})\) ([2-9]\d{2})-\d{4}$/;

      return regex.test(value);
    }),
  // jsI_POC: yup
  //   .string()
  //   .email("Enter a valid email")
  //   .required("JSI-POC Contact is required"),

  zipCode: yup
    .number()
    .nullable()
    .test(
      "zipCode",
      "Enter a valid US ZIP code",
      (value) => {
        if (value == null) return true; // allow null
        const digits = String(value);
        return /^\d{5}(\d{4})?$/.test(digits);
      }
    )
});

export default function CustomerForm() {
  const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const customerContext = useContext(CustomerContext);
  const filingMasterContext = useContext(FilingMasterContext);
  const { authUser, roleType, roleDetails } = authContext;
  const { brandingCacheRef } = useCommonDetailsContext();
  const [isLoadingParentDropdown, setIsLoadingParentDropdown] = useState(false)
  const {
    createCustomer,
    customers,
    getCustomers,
    customerLoaded,
    customerLoading,
    createCustomerBusinessCategories,
    createCustomerProgramNames,
    deleteCustomerBusinessCategories,
    setCurrentCustomer,
    selectedCustomer,
    updateCustomer,
    // updateCustomerPostAward,
    initiateClientFilingWorkflow,
    initiatePostClientFilingWorkflow,
  } = customerContext;
  const { getBusinessCategories, getProgramName } = filingMasterContext;
  const [alertMessage, setAlertMessage] = React.useState<string | JSX.Element>(
    ""
  );
  // const [alertMessage, setAlertMessage] = React.useState<{
  // message: string;
  // type: AlertColor;
  // }>({ message: "", type: "success" });
  // const { showAlert, showSnackbar } = alertContext;
  const [categories, setCategories] = useState<BusinessCategory[]>([]);
  const [programOptions, setProgramOptions] = useState<ProgramName[]>([]);
  const [initialProgramNames, setInitialProgramNames] = useState<any[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedPrograms, setSelectedPrograms] = useState<any[]>([]);
  const [selectedState, setSelectedState] = useState<string[]>([]);
  const [categoriesErrorText, setCategoriesErrorText] = useState<string>("");
  const [programsErrorText, setProgramsErrorText] = useState<string>("");
  const [stateErrorText, setStateErrorText] = useState<string>("");
  const [isCategoryChanged, setIsCategoryChanged] = useState(false);
  const [isProgramsChanged, setIsProgramsChanged] = useState(false);
  const [isStateChanged, setIsStateChanged] = useState(false);
  const [initCategories, setInitCategories] = useState<string[]>([]);
  const [initStates, setInitStates] = useState<string[]>([]);
  const [formTitle, setFormTitle] = useState<string>("ADD NEW CLIENT");
  const [actionLabel, setActionLabel] = useState<string>("Add");

  const [openOption, setOpenOption] = useState(false);
  const [remainingChars, setRemainingChars] = useState(2000);
  const [openSnack, setOpenSnack] = React.useState("");
  const [parentClientError, setParentClientError] = React.useState("");
  const [childClientError, setChildClientError] = React.useState("");
  const [isAdminParentEdit, setIsAdminParentEdit] = React.useState<any>();
  const fontStyle = {
    fontWeight: "regular",
    fontSize: "13px",

    color: "#424242",
  };
  const hasRole = (roleName: string) =>
    Array.isArray(roleType) ? roleType.includes(roleName) : roleType === roleName;
  const hasTrackNowSubscriptionAccess =
    hasRole("JSIPOC") ||
    hasRole("Admin") ||
    hasRole("JSISME") ||
    hasRole("HierarchyAdmin");
  const hasPostAwardSubscriptionAccess =
    hasRole("JSIPOC-PostAward") ||
    hasRole("JSISME-PostAward") ||
    hasRole("Admin-PostAward") ||
    hasRole("HierarchyAdmin-PostAward");
  // const toast = useRef(null);
  const roles = Array.isArray(roleType) ? roleType : (roleType ? [roleType] : []);
  const isOnlyHierarchyAdmin =
    roles.length > 0 &&
    roles.some(
      (role: string) => role === "HierarchyAdmin" || role === "HierarchyAdmin-PostAward"
    ) &&
    !roles.some((role: string) =>
      ["Admin", "Admin-PostAward", "JSIPOC", "JSIPOC-PostAward", "JSISME", "JSISME-PostAward"].includes(role)
    );

  const hasParentInRoleDetails =
    Array.isArray(roleDetails) &&
    roleDetails.some(
      (item: any) =>
        item?.customerType?.toLowerCase() === "parent" ||
        item?.clientType?.toLowerCase() === "parent"
    );

  const hasChildInRoleDetails =
    Array.isArray(roleDetails) &&
    roleDetails.some(
      (item: any) =>
        item?.customerType?.toLowerCase() === "child" ||
        item?.clientType?.toLowerCase() === "child"
    );

  const hasSubChildInRoleDetails =
    Array.isArray(roleDetails) &&
    roleDetails.some(
      (item: any) =>
        item?.customerType?.toLowerCase() === "subchild" ||
        item?.clientType?.toLowerCase() === "subchild"
    );

  const isParentRadioDisabled =
    isOnlyHierarchyAdmin ? true : false;

  const isChildRadioDisabled =
    isOnlyHierarchyAdmin ? !hasParentInRoleDetails : false;

  const isSubChildRadioDisabled =
    isOnlyHierarchyAdmin ? (!hasParentInRoleDetails && !hasChildInRoleDetails) : false;

  console.log("formTitle1", formTitle);

  const licenseTypes = [
    { TrackNowLicenseId: 0, TrackNowLicenseName: "None" },
    { TrackNowLicenseId: 1, TrackNowLicenseName: "Essential" },
    { TrackNowLicenseId: 2, TrackNowLicenseName: "plus" },
    { TrackNowLicenseId: 3, TrackNowLicenseName: "Premium" },
  ];

  const postAwardLicenseTypes = [
    { PostAwardLicenseId: 0, PostAwardLicenseName: "None" },
    { PostAwardLicenseId: 1, PostAwardLicenseName: "Essential" },
    { PostAwardLicenseId: 2, PostAwardLicenseName: "Premium" },
    { PostAwardLicenseId: 3, PostAwardLicenseName: "Platinum" },
  ];

  const initForm: Customer = {
    customerId: 0,
    customerName: "",
    businessCategoryId: 0,
    parentCustomerId: 0,
    childCustomerId: null,
    jsI_POC: "",
    //licenseFullName: "",
    trackNowLicenseId: "",
    postAwardLicenseId: "",
    //liscenseShortName: "",
    state: [],
    customerState: [],
    // businessCategories:[],
    // createDate: null,
    // createUser: null,
    // updateDate: null,
    // updateUser: null,
  };
  const [showAlert, setShowAlert] = React.useState(false);
  const [customer, setCustomer] = React.useState<Customer>(initForm);
  const [parentClientsList, setParentClientsList] = React.useState<IClient[]>([]);
  const [childClientsList, setChildClientsList] = React.useState<IClient[]>([]);
  const [isLoadingChildList, setIsLoadingChildList] = useState(false)
  const [parentClient, setParentClient] = React.useState<IClient | null>(null);
  const [childClient, setChildClient] = React.useState<IClient | null>(null);
  const [selectedParentName, setSelectedParentName] =
    React.useState<string>("");
  const [selectedChildName, setSelectedChildName] =
    React.useState<string>("");
  const [initParentClient, setInitParentClient] =
    React.useState<IClient | null>(null);
  const [initParentName, setInitParentName] = React.useState<string>("");
  const [initChildClient, setInitChildClient] =
    React.useState<IClient | null>(null);
  const [initChildName, setInitChildName] = React.useState<string>("");
  const [clientType, setClientType] = React.useState<string>("Parent");
  const [brandingConfig, setBrandingConfig] = React.useState<IBrandingForm>(DEFAULT_BRANDING_VALUES);
  const [hasExistingBranding, setHasExistingBranding] = React.useState<boolean>(false);
  const [isCustomBrandingConfigured, setIsCustomBrandingConfigured] = React.useState<boolean>(false);
  const [pendingBrandingAction, setPendingBrandingAction] = React.useState<IPendingBrandingAction | null>(null);
  const pendingBrandingActionRef = useRef<IPendingBrandingAction | null>(null);
  const prevCustomerIdRef = useRef<number | null | undefined>(undefined);
  const [openBrandingModal, setOpenBrandingModal] = React.useState<boolean>(false);

  const handleBrandingSaved = (savedConfig: IBrandingForm, action?: IPendingBrandingAction) => {
    console.log("CustomerForm handleBrandingSaved:", savedConfig, action);
    setBrandingConfig(savedConfig);
    setHasExistingBranding(true);
    setIsCustomBrandingConfigured(true);
    const resolvedAction = action || (savedConfig ? { type: "CREATE" as const } : null);
    setPendingBrandingAction(resolvedAction);
    pendingBrandingActionRef.current = resolvedAction;
  };

  const isDraftBrandingConfigured = React.useMemo(() => {
    if (!brandingConfig) return false;
    const isPrimaryCustom = Boolean(
      brandingConfig.primaryColor &&
      brandingConfig.primaryColor.toLowerCase() !== (DEFAULT_BRANDING_VALUES.primaryColor || "#001a77").toLowerCase()
    );
    const isBgCustom = Boolean(
      brandingConfig.backgroundColor &&
      brandingConfig.backgroundColor.toLowerCase() !== (DEFAULT_BRANDING_VALUES.backgroundColor || "#001a77").toLowerCase() &&
      brandingConfig.backgroundColor.toLowerCase() !== (tokens.colors.offWhite || "#f8f9fc").toLowerCase()
    );
    const isFontCustom = Boolean(
      brandingConfig.fontFamily &&
      brandingConfig.fontFamily !== (DEFAULT_BRANDING_VALUES.fontFamily || "Roboto")
    );
    const hasLogo = Boolean(
      brandingConfig.logoUrl ||
      brandingConfig.logoDataUrl ||
      brandingConfig.logoPreviewUrl ||
      brandingConfig.logoFile
    );
    return isPrimaryCustom || isBgCustom || isFontCustom || hasLogo;
  }, [brandingConfig]);

  const showResetButton = !selectedCustomer?.customerId && isDraftBrandingConfigured;
  const isBrandingCustomized = isDraftBrandingConfigured || hasExistingBranding;

  const handleResetBranding = () => {
    setBrandingConfig(DEFAULT_BRANDING_VALUES);
    setHasExistingBranding(false);
    setIsCustomBrandingConfigured(false);
    setPendingBrandingAction(null);
    pendingBrandingActionRef.current = null;
    const custId = selectedCustomer?.customerId || customer?.customerId;
    if (custId) {
      const key = String(custId);
      if (brandingCacheRef?.current?.has(key)) {
        brandingCacheRef.current.delete(key);
      }
    }
  };

  const isBrandingRoleIncludes = Array.isArray(roleType)
    ? roleType.some((role: string) =>
      [
        "Admin",
        "Admin-PostAward",
        "ClientAdmin",
        "ClientAdmin-PostAward",
        "HierarchyAdmin",
        "HierarchyAdmin-PostAward",
      ].includes(role)
    )
    : [
      "Admin",
      "Admin-PostAward",
      "ClientAdmin",
      "ClientAdmin-PostAward",
      "HierarchyAdmin",
      "HierarchyAdmin-PostAward",
    ].includes(roleType);
  const isAdminRoleEdit = Boolean(selectedCustomer?.customerId)
  console.log("roleDetails", roleDetails, selectedCustomer?.customerId, Boolean(selectedCustomer?.customerId));

  const fileToDataUrl = (file: File): Promise<string | null> =>
    new Promise((resolve, reject) => {
      if (!file) {
        resolve(null);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  useEffect(() => {
    const custId = selectedCustomer?.customerId;
    if (custId !== prevCustomerIdRef.current) {
      prevCustomerIdRef.current = custId;
      setPendingBrandingAction(null);
      pendingBrandingActionRef.current = null;
    }
    const isParent = String(clientType || "").toLowerCase() === "parent" || (!selectedCustomer?.parentCustomer && !parentClient);
    if (custId && isParent) {
      axios
        .get(
          `${API_BASE_URL}/Application/GetBrandingConfiguration?CustomerId=${custId}&CustomerType=Parent`
        )
        .then((res) => {
          const data =
            res.data?.data ||
            (Array.isArray(res.data) ? res.data[0] : res.data);
          if (data && (data.primaryColor || data.PrimaryColor)) {
            setBrandingConfig({
              primaryColor: data.primaryColor || data.PrimaryColor || "#001a77",
              backgroundColor:
                data.backgroundColor ||
                data.BackgroundColor ||
                tokens.colors.offWhite,
              fontFamily: data.fontFamily || data.FontFamily || "Roboto",
              logoUrl: data.logoUrl || data.LogoUrl || "",
              logoDataUrl: data.logoDataUrl || data.LogoDataUrl || "",
              logoPreviewUrl: data.logoDataUrl || data.LogoDataUrl || "",
            });
          } else {
            setBrandingConfig(DEFAULT_BRANDING_VALUES);
          }
        })
        .catch((err) => {
          console.log("GetBrandingConfiguration error in CustomerForm:", err);
          setHasExistingBranding(false);
          setBrandingConfig(DEFAULT_BRANDING_VALUES);
        });
      getBrandingHistory();
    } else if (!selectedCustomer) {
      setHasExistingBranding(false);
      setIsCustomBrandingConfigured(false);
      setBrandingConfig(DEFAULT_BRANDING_VALUES);
      setPendingBrandingAction(null);
      pendingBrandingActionRef.current = null;
    }
  }, [selectedCustomer?.customerId, clientType]);
  const getBrandingHistory = async () => {
    if (selectedCustomer?.customerId) {
      const res = await axios.get(
        `${API_BASE_URL}/Application/GetBrandingConfigurationHistory?CustomerId=${selectedCustomer?.customerId}`
      );

      const rawData = res.data?.data ?? res.data;
      const length = Array.isArray(rawData)
        ? rawData.length
        : Array.isArray(res.data)
          ? res.data.length
          : (rawData && (rawData.primaryColor || rawData.PrimaryColor || rawData.brandingId || rawData.BrandingId) ? 1 : 0);

      const hasBranding = length > 1;
      console.log("rawData", rawData, "length", length, "hasBranding", hasBranding);

      setHasExistingBranding(hasBranding);
    }
  }

  const navigate = useNavigate();
  const searchRef = useRef<HTMLInputElement>(null);
  const [stateList, setStateList] = useState([]);
  const backToHome = () => {
    navigate("/");
  };
  const onChange = async (e: React.ChangeEvent<any>) => {
    // await hasTokenExpired();
    // let value = "";
    // if (e.target.name === "groupName") {
    // getGroupId();
    // }
    console.log(`Setting [${e.target.name}]: ${e.target.value}`);
    setCustomer((cust) => ({ ...cust, [e.target.name]: e.target.value }));
  };

  const handleCategoryChange = (event: SelectChangeEvent) => {
    const {
      target: { value },
    } = event;
    setCustomer((cust) => ({ ...cust, businessCatergoryId: parseInt(value) }));
  };

  const handleStateChange = (event: SelectChangeEvent) => {
    const {
      target: { value },
    } = event;
    setCustomer((cust) => ({ ...cust, state: [value] }));
  };

  const addCategoriers = async (cats: string[]): Promise<boolean> => {
    console.log(`Add Business Category changes for`, cats);
    return new Promise(async (resolve, reject) => {
      if (createCustomerBusinessCategories && cats.length > 0) {
        try {
          const payloadList = cats.map((item) => ({
            customerId: customer.customerId,
            businessCategoryId: item,
          }));

          const res = await createCustomerBusinessCategories(payloadList);
          if (res) {
            resolve(true);
          }
        } catch (error) {
          console.log(
            `Error while saving Client Business Category changes`,
            error
          );
          reject(false);
        }
      } else {
        resolve(true);
      }
    });
  };
  const getRecordIdForDelete = (catId: string): number => {
    let _id;
    if (selectedCustomer && selectedCustomer.businessCategory) {
      _id = selectedCustomer?.businessCategory.filter(
        (item) => !item.state && item.businessCategoryId === parseInt(catId)
      )[0].id;
    }
    return _id ? _id : 0;
  };

  const deleteCategoriers = (cats: string[]): Promise<boolean> => {
    console.log(`Delete Business Category changes for`, cats);
    return new Promise(async (resolve, reject) => {
      if (deleteCustomerBusinessCategories && cats.length > 0) {
        let promises: Promise<boolean>[] = [];
        cats.forEach((item) => {
          promises.push(
            new Promise(async (resolve, reject) => {
              try {
                const _id = getRecordIdForDelete(item);
                const res = await deleteCustomerBusinessCategories(_id);
                console.log(`deleteCategoriers res`, res);
                if (res.data.status === "Failure") {
                  console.log(`Delete Business Category failure`, res.data);
                  // Resolve with false when "Failure"
                  setAlertMessage(res.data.errorMessage);
                  setShowAlert(true);
                  resolve(false);
                } else {
                  console.log(`Delete Business Category success`);
                  resolve(true); // Resolve with true for success
                }
              } catch (error) {
                reject(false);
              }
            })
          );
        });
        return Promise.all(promises)
          .then((results) => {
            const allSuccess = results.every((res) => res === true);
            if (allSuccess) {
              console.log(`Delete Business Category success`);
              resolve(true);
            } else {
              console.log(`Delete Business Category failure`);
              reject(false);
            }
          })
          .catch((err) => reject(false));
      } else {
        resolve(true);
      }
    });
  };

  const submitForm = async () => {
    console.log(`Submitting Add Customer: [${JSON.stringify(customer)}]`);
    const _parentCustomerId =
      parentClient && parentClient.customerId ? parentClient.customerId : 0;
    const _childCustomerId =
      childClient && childClient.customerId ? childClient.customerId : null;
    const targetCustomerId = Number(
      selectedCustomer?.customerId ||
      customer?.customerId ||
      formik.values?.customerId ||
      0
    );
    setIsLoading(true);
    try {
      if (createCustomer) {
        let _cust: any = {
          ...formik.values,
          customerId: targetCustomerId,
          parentCustomerId: _parentCustomerId,
          childCustomerId: _childCustomerId,
          customerType: clientType,
        };
        //   const _liscenseType = {
        //     trackNowLicenseId: 0,
        //     trackNowLicenseName: _cust.trackNowLicenseName,
        //     //liscenseShortName: _cust.liscenseShortName,
        //   };
        //   console.log("TRACKLISCENSETYPE", _liscenseType);

        //   const _postLiscenseType = {
        //     postAwardLicenseId: 0,
        //     postAwardLicenseName: _cust.postAwardLicenseName,
        //     //liscenseShortName: _cust.liscenseShortName,
        //   };
        //  console.log("POSTLISCENSETYPE", _postLiscenseType);

        // delete _cust.businessCatergoryId;
        console.log(`Submitting Add Customer2: ${_cust}`);
        let res: Customer;
        console.log("fcustomer", customer);
        console.log(
          `Submitting Add Customer2:"`,
          formik.values.trackNowLicenseId === 0 ||
          formik.values.trackNowLicenseId === "",
          formik.values.postAwardLicenseId === 0 ||
          formik.values.postAwardLicenseId === ""
        );
        if (
          (formik.values.trackNowLicenseId === 0 ||
            formik.values.trackNowLicenseId === "") &&
          (formik.values.postAwardLicenseId === 0 ||
            formik.values.postAwardLicenseId === "")
        ) {
          if (hasTrackNowSubscriptionAccess && !hasPostAwardSubscriptionAccess) {
            setAlertMessage(`Please select TrackNow Subscription`);
          } else if (hasPostAwardSubscriptionAccess && !hasTrackNowSubscriptionAccess) {
            setAlertMessage(`Please select Post Award Subscription`);
          } else {
            setAlertMessage(
              `Please select either TrackNow Subscription or Post Award Subscription`
            );
          }
          setShowAlert(true);
          return null;
        }
        if (
          targetCustomerId > 0 &&
          updateCustomer
          // && updateCustomerPostAward
        ) {
          console.log("custtt", _cust);
          // const updLiscenseType = {
          //   trackNowLicenseName: _cust.trackNowLicenseName,
          // };
          // let res5 = await axios.put(
          //   `${API_BASE_URL}/Customer/UpdateTrackNowLicense/${customer. trackNowLicenseId}`,
          //   updLiscenseType
          // );
          // if (res5) {
          //   _cust. trackNowLicenseId = customer. trackNowLicenseId;
          // }
          if (clientType == "Parent") {
            _cust.parentCustomerId = 0;
            _cust.childCustomerId = null;
          }
          _cust.updateDate = new Date();
          _cust.updateUser = authUser?.userId + "";
          // delete _cust.businessCatergoryId;
          // delete _cust.notes;
          // delete _cust.poc;

          let updStateInfo: any[] = selectedState.map((item: any) => {
            const customerState = selectedCustomer?.customerState?.find(
              (state: any) => state.state === item
            );
            const stateId = customerState ? customerState.stateId : 0;

            return {
              stateId: stateId,
              customerId: _cust.customerId,
              state: item,
            };
          });

          let deleteState: number[] = [];

          if (selectedCustomer && selectedCustomer.customerState) {
            deleteState = selectedCustomer.customerState
              .filter((state: any) => !selectedState.includes(state.state))
              .map((state: any) => state.stateId);
          }

          if (deleteState.length > 0) {
            for (let stateId of deleteState) {
              await axios.delete(
                `${API_BASE_URL}/Customer/DeleteCustomerState/${stateId}`
              );
            }
          }

          console.log("updStateInfo", updStateInfo);
          console.log("deleteState", deleteState);

          let updState = await axios.put(
            `${API_BASE_URL}/Customer/UpdateCustomerState`,
            updStateInfo
          );
          console.log("updState", updState);

          delete _cust.state;
          delete _cust.customerState;

          let PN: any =
            selectedCustomer && selectedCustomer.programinfo
              ? selectedCustomer.programinfo
              : [];

          //Find what is changed in programnames
          console.log("programnames", selectedPrograms, initialProgramNames);
          const _delProgs = _.difference(initialProgramNames, selectedPrograms);
          let _addProgs = _.difference(selectedPrograms, initialProgramNames);
          console.log("programnames", _delProgs, _addProgs);

          if (_delProgs.length > 0) {
            console.log(
              "programnamesDEL",
              _delProgs,
              selectedCustomer && selectedCustomer.programinfo
            );
            PN = PN.filter(
              (ele: any) => !_delProgs.includes(ele.programId + "")
            );
          }
          if (_addProgs.length > 0) {
            console.log("programnamesADD", _addProgs);
            _addProgs.forEach((ele) => {
              PN.push({
                customerProgramId: 0,
                programId: parseInt(ele),
                createDate: new Date(),
                createUser: authUser?.userId + "",
              });
            });
          }
          console.log("programnames", PN);

          _cust.programName = PN.map((ele: any) => ({
            customerProgramId: ele.customerProgramId,
            customerId:
              selectedCustomer &&
              selectedCustomer.customerId &&
              selectedCustomer.customerId,
            programId: ele.programId,
            updateDate: new Date(),
            updateUser: authUser?.userId + "",
          }));

          _cust.state = updStateInfo.reduce(
            (states, item, i) =>
              i === 0 ? item.state : `${states} , ${item.state}`,
            ""
          );

          let BC: any =
            selectedCustomer && selectedCustomer.businessCategory
              ? selectedCustomer.businessCategory
              : [];

          //Find what is changed in categories
          const _delCats = _.difference(initCategories, selectedCategories);
          let _addCats = _.difference(selectedCategories, initCategories);

          if (_delCats.length > 0) {
            console.log(
              "&&& DEL CATS",
              _delCats,
              selectedCustomer && selectedCustomer.businessCategory
            );
            BC = BC.filter((ele: any) =>
              _delCats.includes(ele.businessCategoryId + "")
                ? _delCats.includes(ele.businessCategoryId + "") &&
                ele.state !== null
                : true
            );
          }
          if (_addCats.length > 0) {
            console.log("&&& ADD CATS", _addCats);
            _addCats.forEach((ele) => {
              BC.push({
                id: 0,
                state: null,
                businessCategoryId: parseInt(ele),
                createDate: new Date(),
                createUser: authUser?.userId + "",
              });
            });
          }
          console.log("&&& CATS", BC);

          _cust.businessCategory = BC.map((ele: any) => ({
            id: ele.id,
            customerId:
              selectedCustomer &&
              selectedCustomer.customerId &&
              selectedCustomer.customerId,
            state: ele.state,
            businessCategoryId: ele.businessCategoryId,
            updateDate: new Date(),
            updateUser: authUser?.userId + "",
          }));

          _cust.state = updStateInfo.reduce(
            (states, item, i) =>
              i === 0 ? item.state : `${states} , ${item.state}`,
            ""
          );
          //  res = await updateCustomer(_cust);

          _cust.postAwardLicenseId =
            formik.values.postAwardLicenseId === 0 ||
              formik.values.postAwardLicenseId === ""
              ? null
              : formik.values.postAwardLicenseId;

          _cust.trackNowLicenseId =
            formik.values.trackNowLicenseId === 0 ||
              formik.values.trackNowLicenseId === ""
              ? null
              : formik.values.trackNowLicenseId;

          _cust.businessCategory =
            formik.values.trackNowLicenseId === 0 || formik.values.trackNowLicenseId === "" || formik.values.trackNowLicenseId === null
              ? []
              : (_cust.businessCategory.length > 0 ? _cust.businessCategory : null);
          _cust.programName =
            formik.values.postAwardLicenseId === 0 || formik.values.postAwardLicenseId === "" || formik.values.postAwardLicenseId === null
              ? []
              : (_cust.programName.length > 0 ? _cust.programName : null);

          console.log(
            "check-cat-prog",
            _cust.businessCategory,
            _cust.programName
          );
          console.log(
            "postlicensename",
            _cust.postAwardLicenseName,
            formik.values.postAwardLicenseName
          );
          let resUpd: any;
          // console.log("value-check",formik.values,formik.values.programName,formik.values.businessCategory)
          resUpd = await updateCustomer(_cust);

          // if (

          //   selectedCustomer &&
          //   selectedCustomer.businessCategory &&
          //   selectedCustomer.businessCategory.length > 0 &&
          //   selectedCustomer &&
          //   selectedCustomer.programinfo &&
          //   selectedCustomer.programinfo.length > 0
          // ) {
          //   // Call both functions
          //   resUpd = await Promise.all([
          //     updateCustomer(_cust),
          //     updateCustomerPostAward(_cust),
          //   ]);
          // } else if (selectedCustomer && selectedCustomer.programinfo && selectedCustomer.programinfo.length > 0) {
          //   resUpd = await updateCustomerPostAward(_cust);
          // } else {
          //   resUpd = await updateCustomer(_cust);
          // }

          console.log("updateCustomer", resUpd);

          if (resUpd.status !== "Failure") {
            if (_cust?.customerId) {
              const key = String(_cust.customerId);
              if (brandingCacheRef?.current?.has(key)) {
                brandingCacheRef.current.delete(key);
              }
            }

            // Handle Branding Configuration in Edit Client mode
            const isParentClient =
              String(clientType || "").toLowerCase() === "parent" ||
              (!selectedCustomer?.parentCustomer && !parentClient);
            const currentAction = pendingBrandingActionRef.current || pendingBrandingAction;

            console.log("Edit Client submitForm - branding check:", {
              isParentClient,
              targetCustomerId,
              currentAction,
              isCustomBrandingConfigured,
              brandingConfig,
            });

            if (isParentClient && targetCustomerId) {
              try {
                if (currentAction?.type === "UPDATE_STATUS" && currentAction?.brandingId) {
                  const payload = {
                    customerId: targetCustomerId,
                    brandingId: currentAction.brandingId,
                    isDefault: true,
                    userId: String(authUser?.userId ?? ""),
                    userName: authUser?.userName || authUser?.loginId || "",
                  };
                  const brandRes = await axios.put(
                    `${API_BASE_URL}/Application/UpdateBrandingDefaultStatus`,
                    payload
                  );
                } else if (currentAction?.type === "CREATE" || isCustomBrandingConfigured) {
                  let hasExistingBranding = false;
                  try {
                    const checkRes = await axios.get(
                      `${API_BASE_URL}/Application/GetBrandingConfiguration?CustomerId=${targetCustomerId}&CustomerType=Parent`
                    );
                    const resData = checkRes.data;
                    const data =
                      resData?.data ||
                      (Array.isArray(resData) ? resData[0] : resData);
                    const isNotFound =
                      resData?.status === "Failure" ||
                      resData?.errorMessage === "Branding Configuration Not Found" ||
                      !data ||
                      (!data.primaryColor && !data.PrimaryColor && !data.brandingId && !data.BrandingId);

                    if (!isNotFound && (data.primaryColor || data.PrimaryColor || data.brandingId || data.BrandingId)) {
                      hasExistingBranding = true;
                    }
                  } catch (err) {
                    console.log("GetBrandingConfiguration check error in CustomerForm edit client:", err);
                    hasExistingBranding = false;
                  }

                  if (!hasExistingBranding) {
                    const defaultPayload = {
                      customerId: targetCustomerId,
                      primaryColor: DEFAULT_BRANDING_VALUES.primaryColor || "#001a77",
                      backgroundColor: DEFAULT_BRANDING_VALUES.backgroundColor || "#001a77",
                      fontFamily: DEFAULT_BRANDING_VALUES.fontFamily || "Roboto",
                      isDefault: true,
                      logoDataUrl: "",
                      userId: String(authUser?.userId ?? ""),
                      userName: authUser?.userName || authUser?.loginId || "",
                      createUser: String(authUser?.userId ?? ""),
                    };
                    console.log("Calling CreateBrandingConfiguration with default payload first:", defaultPayload);
                    await axios.post(
                      `${API_BASE_URL}/Application/CreateBrandingConfiguration`,
                      defaultPayload
                    );
                  }

                  let resolvedLogo = brandingConfig.logoDataUrl || "";
                  if (brandingConfig.logoFile) {
                    resolvedLogo = (await fileToDataUrl(brandingConfig.logoFile)) || "";
                  }
                  const selectedBrandingPayload = {
                    customerId: targetCustomerId,
                    primaryColor: brandingConfig.primaryColor || DEFAULT_BRANDING_VALUES.primaryColor || "#001a77",
                    backgroundColor: brandingConfig.backgroundColor || DEFAULT_BRANDING_VALUES.backgroundColor || "#001a77",
                    fontFamily: brandingConfig.fontFamily || DEFAULT_BRANDING_VALUES.fontFamily || "Roboto",
                    isDefault: true,
                    logoDataUrl: resolvedLogo,
                    userId: String(authUser?.userId ?? ""),
                    userName: authUser?.userName || authUser?.loginId || "",
                    createUser: String(authUser?.userId ?? ""),
                  };
                  console.log("Calling CreateBrandingConfiguration with payload:", selectedBrandingPayload);
                  const brandRes = await axios.post(
                    `${API_BASE_URL}/Application/CreateBrandingConfiguration`,
                    selectedBrandingPayload
                  );
                  console.log("CreateBrandingConfiguration response:", brandRes?.data);
                }

                const key1 = String(targetCustomerId);
                const key2 = `${targetCustomerId}_Parent`;
                if (brandingCacheRef?.current?.has(key1)) {
                  brandingCacheRef.current.delete(key1);
                }
                if (brandingCacheRef?.current?.has(key2)) {
                  brandingCacheRef.current.delete(key2);
                }
              } catch (brandErr) {
                console.error("Error updating branding configuration for parent client in edit mode:", brandErr);
              }
            }
            console.log(
              "postAward--",
              selectedCustomer?.postAwardLicenseId,
              formik.values?.postAwardLicenseId
            );
            console.log(
              "TracknowCheck-selCust",
              selectedCustomer,
              "FormValues",
              formik.values
            );

            console.log("SUBSCRIPTIPN CHECK");

            if (
              (selectedCustomer?.postAwardLicenseId === 0 ||
                selectedCustomer?.postAwardLicenseId === null) &&
              formik.values?.postAwardLicenseId !== 0 &&
              formik.values?.postAwardLicenseId !== "" &&
              selectedCustomer?.postAwardLicenseId !==
              formik.values?.postAwardLicenseId
            ) {
              let result1 = await postAwardWorkFlowGenerator(
                selectedCustomer?.customerId,
                authUser?.userId,
                "add"
              );
              console.log("result1", result1);
            }
            delete _cust.selectedParentName;

            if (_delCats.length === 0 && _addCats.length === 0) {
              console.log("&&& NO Change to categories");
              console.log(
                "UPDCHECK1",
                "resUpd",
                resUpd,
                "errorMessage",
                resUpd.errorMessage
              );

              setAlertMessage(
                <Typography>
                  Successfully Updated Client:{" "}
                  <strong>{formik.values.customerName}</strong>
                </Typography>
              );
              setShowAlert(true);
            } else {
              if (
                selectedCustomer?.trackNowLicenseId !==
                formik.values?.trackNowLicenseId ||
                _delCats.length > 0 ||
                _addCats.length > 0
              ) {
                console.log(
                  "UPDCHECK0",
                  selectedCustomer?.trackNowLicenseId !==
                  formik.values?.trackNowLicenseId
                );
                if (initiateClientFilingWorkflow) {
                  let payloadWorkflow = _addCats.map((item) => ({
                    customerId: res?.customerId,
                    businessCategoryId: item,
                    businessOperation: "add",
                  }));
                  _delCats.forEach((item) => {
                    payloadWorkflow.push({
                      customerId: res?.customerId,
                      businessCategoryId: item,
                      businessOperation: "delete",
                    });
                  });
                  let result = await initiateClientFilingWorkflow(
                    customer.customerId,
                    payloadWorkflow
                  );
                  console.log("&&& initiateClientFilingWorkflow", result);
                  if (result) {
                    console.log(
                      "UPDCHECK2",
                      "resUpd",
                      resUpd,
                      "errorMessage",
                      resUpd.errorMessage
                    );
                    if (resUpd && resUpd.errorMessage) {
                      console.log(
                        "UPDCHECK2.1",
                        "resUpd",
                        resUpd,
                        "errorMessage",
                        resUpd.errorMessage
                      );
                      setSelectedCategories(() => []);
                      setInitCategories(() => []);
                      setAlertMessage(
                        // `Successfully Updated Client:${formik.values.customerName}`
                        resUpd.errorMessage
                      );
                      setShowAlert(true);
                      setRemainingChars(2000);
                    } else {
                      console.log(
                        "UPDCHECK2.2",
                        "resUpd",
                        resUpd,
                        "errorMessage",
                        resUpd.errorMessage
                      );
                      setSelectedCategories(() => []);
                      setInitCategories(() => []);

                      setAlertMessage(
                        <Typography>
                          Successfully Updated Client:
                          <strong>{formik.values.customerName}</strong>
                        </Typography>
                      );
                      setShowAlert(true);
                      setRemainingChars(2000);
                    }
                  }
                }
              }
            }
          } else {
            setAlertMessage(`Unexpected Error occured while updating Client`);
            setShowAlert(true);
            setRemainingChars(2000);
          }
        } else {
          //   const res3 = await axios.post(
          //     `${API_BASE_URL}/Customer/CreateTrackNowLicense`,
          //     _liscenseType
          //   );
          //  console.log("res3", res3.data.data);
          //   const licenseId = res3.data.data.tracknowLicenseId
          //   console.log("licenseId", licenseId);

          const postAwardLicenseId = formik.values?.postAwardLicenseId;
          const tracknowLiscenseId = formik.values?.trackNowLicenseId;
          console.log("postawardlicensestype", postAwardLicenseId);
          console.log("PAL", postAwardLicenseId, formik.values);
          _cust.postAwardLicenseId =
            formik.values.postAwardLicenseId === 0 ||
              formik.values.postAwardLicenseId === ""
              ? null
              : formik.values.postAwardLicenseId;
          const trackNowLicenseId = formik.values.trackNowLicenseId;
          console.log("tracknowlicensestype", trackNowLicenseId);
          console.log("TNL", trackNowLicenseId, formik.values);
          // _cust.trackNowLicenseId = licenseId;
          _cust.trackNowLicenseId =
            formik.values.trackNowLicenseId === 0 ||
              formik.values.trackNowLicenseId === ""
              ? null
              : formik.values.trackNowLicenseId;
          _cust.createDate = new Date();
          _cust.createUser = authUser?.userId + "";
          console.log("CUSTLIST", _cust);
          let stateInfo: any[] = selectedState.map((state: any) => ({
            stateId: 0,
            customerId: null,
            state: state,
          }));
          delete _cust.state;
          delete _cust.customerState;
          console.log("stateInfo", stateInfo);
          _cust.state = stateInfo.reduce(
            (states, item, i) =>
              i === 0 ? item.state : `${states} , ${item.state}`,
            ""
          );
          console.log("_cust", _cust);
          console.log(
            "FormValCheck#",
            formik.values,
            "CUST",
            _cust,
            "tracknowLiscenseId",
            tracknowLiscenseId
          );

          res = await createCustomer(_cust);

          if (res) {
            if (res.customerId) {
              const key = String(res.customerId);
              if (brandingCacheRef?.current?.has(key)) {
                brandingCacheRef.current.delete(key);
              }
            }
            if (postAwardLicenseId) {
              postAwardWorkFlowGenerator(
                res.customerId,
                authUser?.userId,
                "add"
              );
            }
            const programPayLoad =
              formik.values.postAwardLicenseId === 0 || formik.values.postAwardLicenseId === "" || formik.values.postAwardLicenseId === null
                ? []
                : programOptions
                  .filter((program) =>
                    selectedPrograms.includes(String(program.programId))
                  )
                  .map(({ programId }) => ({
                    programId,
                    customerId: res.customerId,
                  }));
            console.log("programPayLoad", programPayLoad);
            let res333 = null;
            if (createCustomerProgramNames) {
              res333 = await createCustomerProgramNames(programPayLoad);
            }

            // const payloadp = programOptions.map((item) => ({
            //   customerId: res.customerId,
            //   programId: item,
            // }));

            // let res11 = null;
            // if (createCustomerProgramNames) {
            //   res11 = await createCustomerProgramNames(payloadp);
            // }

            // if (res11) {
            //   if (postAwardLicenseId) {
            //     if (initiatePostClientFilingWorkflow) {
            //       const payloadWorkflows = programOptions.map((item) => ({
            //         customerId: res.customerId,
            //         programId: item,
            //         businessOperation: "add",
            //         state: null,
            //       }));
            //       await initiatePostClientFilingWorkflow(res.customerId, payloadWorkflows);
            //     }
            //   }
            //   setAlertMessage(`Successfully Added Client:${formik.values.customerName}`);
            //   setShowAlert(true);
            //   // navigate("/");
            // } else {
            //   setAlertMessage(`Unexpected Error occurred while adding Client`);
            //   setShowAlert(true);
            // }

            const payload =
              formik.values.trackNowLicenseId === 0 || formik.values.trackNowLicenseId === "" || formik.values.trackNowLicenseId === null
                ? []
                : selectedCategories.map((item) => ({
                  customerId: res.customerId,
                  businessCategoryId: item,
                }));
            let res1 = null;
            if (createCustomerBusinessCategories) {
              res1 = await createCustomerBusinessCategories(payload);
            }
            if (res1) {
              if (tracknowLiscenseId) {
                if (initiateClientFilingWorkflow) {
                  const payloadWorkflow = selectedCategories.map((item) => ({
                    customerId: res.customerId,
                    businessCategoryId: item,
                    businessOperation: "add",
                    state: null,
                  }));
                  await initiateClientFilingWorkflow(
                    res.customerId,
                    payloadWorkflow
                  );
                }
              }
              setAlertMessage(
                <Typography>
                  Successfully Added Client:{" "}
                  <strong>{formik.values.customerName}</strong>
                </Typography>
              );
              setShowAlert(true);
              // navigate("/");
            } else {
              setAlertMessage(`Unexpected Error occured while adding Client`);
              setShowAlert(true);
            }

            if (stateInfo[0]?.state.length > 0) {
              stateInfo.forEach((obj) => {
                obj.customerId = res.customerId;
              });
              const resState = await axios.post(
                `${API_BASE_URL}/Customer/CreateCustomerState`,
                stateInfo
              );
              console.log("resState", resState.data.data);
            }

            // Create branding configuration for new Parent client if authorized
            if (clientType === "Parent" && isBrandingRoleIncludes && res?.customerId) {
              try {
                // 1. Create branding configuration with default value first
                const defaultPayload = {
                  customerId: res.customerId,
                  primaryColor: DEFAULT_BRANDING_VALUES.primaryColor || "#001a77",
                  backgroundColor: DEFAULT_BRANDING_VALUES.backgroundColor || "#001a77",
                  fontFamily: DEFAULT_BRANDING_VALUES.fontFamily || "Roboto",
                  isDefault: true,
                  logoDataUrl: "",
                  userId: String(authUser?.userId ?? ""),
                  userName: authUser?.userName || authUser?.loginId || "",
                  createUser: String(authUser?.userId ?? ""),
                };
                await axios.post(
                  `${API_BASE_URL}/Application/CreateBrandingConfiguration`,
                  defaultPayload
                );

                // 2. If user configured custom branding, then create branding configuration with selected value
                if (isCustomBrandingConfigured) {
                  let resolvedLogo = brandingConfig.logoDataUrl || "";
                  if (brandingConfig.logoFile) {
                    resolvedLogo = (await fileToDataUrl(brandingConfig.logoFile)) || "";
                  }
                  const selectedBrandingPayload = {
                    customerId: res.customerId,
                    primaryColor: brandingConfig.primaryColor || DEFAULT_BRANDING_VALUES.primaryColor || "#001a77",
                    backgroundColor: brandingConfig.backgroundColor || DEFAULT_BRANDING_VALUES.backgroundColor || "#001a77",
                    fontFamily: brandingConfig.fontFamily || DEFAULT_BRANDING_VALUES.fontFamily || "Roboto",
                    isDefault: true,
                    logoDataUrl: resolvedLogo,
                    userId: String(authUser?.userId ?? ""),
                    userName: authUser?.userName || authUser?.loginId || "",
                    createUser: String(authUser?.userId ?? ""),
                  };
                  await axios.post(
                    `${API_BASE_URL}/Application/CreateBrandingConfiguration`,
                    selectedBrandingPayload
                  );
                }

                if (res?.customerId) {
                  const key = String(res.customerId);
                  if (brandingCacheRef?.current?.has(key)) {
                    brandingCacheRef.current.delete(key);
                  }
                }
              } catch (brandErr) {
                console.error("Error creating initial branding configuration for parent client:", brandErr);
              }
            }
          } else {
            setAlertMessage(`Unexpected Error occured while adding Client`);
            setShowAlert(true);
          }
        }
      }
    } catch (error) {
      console.error("ERRR", error);
      setAlertMessage(`Unexpected Error occured while adding Client`);
      setShowAlert(true);
    } finally {
      setIsLoading(false);
      if (getCustomers) {
        await getCustomers()
      }
    }
  };
  const formatZipCode = (value?: number | null) => {
    const digits = String(value ?? "").slice(0, 9);

    return digits.length <= 5
      ? digits
      : `${digits.slice(0, 5)}-${digits.slice(5)}`;
  };
  const postAwardWorkFlowGenerator = async (
    customerId: any,
    userId: any,
    subscriptionOperation: any
  ) => {
    console.log(
      "postAwardWorkFlowGenerator",
      customerId,
      userId,
      subscriptionOperation
    );
    if (initiatePostClientFilingWorkflow) {
      try {
        let res = await initiatePostClientFilingWorkflow(
          customerId,
          userId,
          subscriptionOperation
        );

        console.log("postAwardWorkFlowGenerator", res);
        return res;
      } catch (error) {
        console.log("error", error);
      }
    }
  };
  const handleCategoryChanges = (
    values: string[],
    keys: any,
    action: string
  ) => {
    console.log("@@Changed BusinessCategories:", values);
    console.log("@@Changed BusinessCategories Action:", action);
    setSelectedCategories((old) => values);
    validateCategories(values);
    // if (values.length > 0) setCategoriesErrorText("");
    // else setCategoriesErrorText("Federal Business Category is required");
    // formik.setFieldValue("businessCategoryId", selectedCategories, false);
    // console.log("@@Changed Is Dirty:",true);
    setIsCategoryChanged(true);
    validateCategories(values, true);
  };
  const handleProgramNameChanges = (
    values: string[],
    keys: any,
    action: string
  ) => {
    console.log("@@Changed ProgramNames:", values);
    console.log("@@Changed Program Action:", action);
    setSelectedPrograms((old) => values);
    // validateProgramNames(values);
    // if (values.length > 0) setCategoriesErrorText("");
    // else setCategoriesErrorText("Federal Business Category is required");
    // formik.setFieldValue("businessCategoryId", selectedCategories, false);
    // console.log("@@Changed Is Dirty:",true);
    setIsProgramsChanged(true);
    // validateProgramNames(values, true);
  };
  const handleStateChanges = (values: string[], keys: any, action: string) => {
    console.log("@@Changed States", values);
    console.log("@@Changed State Action:", action);
    setSelectedState((old) => values);

    setIsStateChanged(true);
    // validateStates(values, true);
  };

  const fetchBusinessCategories = async () => {
    console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      console.log("@@Fetch BusinessCategories:");
      try {
        let catList = await getBusinessCategories();
        // Sorting filteredCatList alphabetically based on businessCategoryName
        console.log("@@BusinessCategories bef:", catList);

        catList.sort((a, b) =>
          (a.businessCategoryName ?? "").localeCompare(
            b.businessCategoryName ?? ""
          )
        );
        console.log("@@BusinessCategories aft:", catList);
        setCategories(() => catList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const fetchProgramName = async () => {
    console.log("@@Fetch ProgramNames:", getProgramName);
    if (getProgramName) {
      console.log("@@Fetch ProgramNames:");
      try {
        let progList = await getProgramName();
        progList = progList.sort((a, b) =>
          (a.programName ?? "").localeCompare(b.programName ?? "")
        );
        console.log("@@ProgramNames:", progList);
        setProgramOptions(() => progList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const fetchCustomers = async () => {
    console.log("@@Fetch Customers:", getCustomers);
    if (getCustomers) {
      setIsLoadingParentDropdown(true)
      let custList;
      if (customers) {
        custList = customers;
      } else {
        custList = await getCustomers();
      }

      const _clientsParent = custList
        .filter((cust) => {
          if (clientType === "SubChild") {
            return cust.parentCustomer === null && cust.bothParentAndChild === true;
          }

          return cust.parentCustomer === null;
        })
        .map((client) => ({
          customerId: client.customerId ?? 0,
          label: client.customerName ?? "",
        }));
      // const _clientsChild = custList
      //   .filter((cust) => cust.childCustomer !== null)
      //   .map((client) => ({
      //     customerId: client.customerId ? client.customerId : 0,
      //     label: client.customerName ? client.customerName : "",
      //   }));
      // _clients.push({ customerId: 0, label: "" });
      const hasAdminRole = Array.isArray(roleType)
        ? roleType.some((role) =>
          ["Admin", "Admin-PostAward"].includes(role)
        )
        : ["Admin", "Admin-PostAward"].includes(roleType);

      let url = `${API_BASE_URL}/Customer/ParentCustomersList`;
      if (!hasAdminRole && authUser?.userId) {
        url += `?userId=${authUser.userId}`;
        if (isOnlyHierarchyAdmin) {
          url += `&isAddClient=true`;
        }
      }
      const resParentList = await axios.get(url);
      let list = Array.isArray(resParentList.data?.data)
        ? resParentList.data.data
        : Array.isArray(resParentList.data)
          ? resParentList.data
          : [];


      const mappedList: IClient[] = list.map((client: any) => ({
        customerId: Number(client.customerId ?? client.code ?? client.parentCustomerId ?? client.id ?? 0),
        label: client.label || client.customerName || client.name || client.parentCustomerName || "",
      }));

      setParentClientsList(() => mappedList);
      setIsLoadingParentDropdown(false);
    }
  };

  const fetchChildCustomers = async () => {
    if (parentClient !== null) {
      setIsLoadingChildList(true);
      setChildClientsList([]); // Clear previous data

      try {
        let url = `${API_BASE_URL}/Customer/ChildCustomerListbyParentId?parentCustomerId=${parentClient.customerId}`;
        if (isOnlyHierarchyAdmin) {
          url += `&userId=${authUser?.userId}`;
        }
        const resChildList = await axios.get(url);

        const _clientsChild = resChildList.data.map((client: any) => ({
          customerId: client.customerId ?? 0,
          label: client.customerName ?? "",
        }));

        setChildClientsList(_clientsChild);
      } finally {
        setIsLoadingChildList(false);
      }
    }
  };
  useEffect(() => {

    if (parentClient !== null) {
      console.log("UF childClient", childClient);

      fetchChildCustomers()
    }
  }, [parentClient])

  useEffect(() => {
    // Add new client page not allowed to show for JSIPOC and JSIPOC POSTAWARD
    const isSingleJSIPOC_JSISME =
      (Array.isArray(roleType) &&
        roleType.length === 1 &&
        (roleType[0] === "JSIPOC" || roleType[0] === "JSIPOC-PostAward")) ||
      (Array.isArray(roleType) &&
        roleType.length === 2 &&
        roleType.includes("JSIPOC") &&
        roleType.includes("JSIPOC-PostAward"));
    console.log(
      "isSingleJSIPOC_JSISME",
      isSingleJSIPOC_JSISME,
      "selectedCustomer",
      selectedCustomer
    );
    if (isSingleJSIPOC_JSISME) {
      if (!selectedCustomer) {
        //   //Navigating to home page if user has either JSIPOC or JSIPOC-POSTAWARD or both
        navigate("/");
      }
    }
  }, []);

  useEffect(() => {
    console.log("programinfo", selectedCustomer?.programinfo);

    if (
      programOptions.length > 0 &&
      selectedCustomer?.programinfo &&
      selectedCustomer?.programinfo.length > 0
    ) {
      const custProgramName = selectedCustomer?.programinfo.map(
        (item) => item.programId + ""
      );
      console.log("programinfo: custProgramName ", custProgramName);
      setSelectedPrograms(custProgramName);
      console.log("programinfo:SelectedPrograms", selectedPrograms);
      setInitialProgramNames(custProgramName);
      // validateProgramNames(custProgramName, true);
    }

    console.log("programinfo:programOptions", programOptions);
    //eslint-disable-next-line
  }, [programOptions]);
  console.log("programinfo:SelectedPrograms", selectedPrograms);

  useEffect(() => {
    if (
      categories &&
      selectedCustomer?.businessCategory &&
      selectedCustomer?.businessCategory.length > 0
    ) {
      const custBusinessCatergory = selectedCustomer?.businessCategory
        .filter((custCat) => custCat.state === null || custCat.state === "")
        .map((item) => item.businessCategoryId + "") as string[];
      console.log("Business cats Custs:", custBusinessCatergory);
      setSelectedCategories(() => custBusinessCatergory);
      console.log("catm");
      setInitCategories(() => custBusinessCatergory);
      validateCategories(custBusinessCatergory, true);
    }

    console.log("@@BusinessCategories Reeeeloaded:", categories);
    //eslint-disable-next-line
  }, [categories]);
  console.log("@@selectedCustomer2:", selectedCustomer);

  useEffect(() => {
    console.log(
      "categories$selectedCustomer",
      selectedCustomer,
      "categories",
      categories
    );
    if (selectedCustomer) {
      if (
        selectedCustomer.postAwardLicenseId &&
        selectedCustomer.trackNowLicenseId &&
        (selectedCustomer.tracknowJSIPOC === null ||
          selectedCustomer.tracknowJSIPOC === "") &&
        (selectedCustomer.postawardJSIPOC === null ||
          selectedCustomer.postawardJSIPOC === "")
      ) {
        console.log("@@selectedCustomerPoc:", selectedCustomer);
        setOpenSnack(
          "TrackNow JSI POC and PostAward JSI POC is not configured. Please Configure in User Roles Page!"
        );
      } else if (
        selectedCustomer.trackNowLicenseId &&
        (selectedCustomer.tracknowJSIPOC === null ||
          selectedCustomer.tracknowJSIPOC === "")
      ) {
        console.log("@@selectedCustomerPoc:", selectedCustomer?.tracknowJSIPOC);
        setOpenSnack(
          "TrackNow JSI POC  is not configured. Please Configure in User Roles Page!"
        );
      } else if (
        selectedCustomer.postAwardLicenseId &&
        (selectedCustomer.postawardJSIPOC === null ||
          selectedCustomer.postawardJSIPOC === "")
      ) {
        console.log("@@selectedCustomerPoc:", selectedCustomer?.tracknowJSIPOC);
        setOpenSnack(
          "PostAward JSI POC is not configured. Please Configure in User Roles Page!"
        );
      }
    }
    //eslint-disable-next-line
  }, [selectedCustomer]);
  console.log("openStack", openSnack);
  useEffect(() => {
    if (
      states &&
      selectedCustomer?.customerState &&
      selectedCustomer?.customerState.length > 0
    ) {
      const stateInfo = selectedCustomer?.customerState
        //.filter((custCat) => custCat.state === null || custCat.state === "")
        .map((item) => item.state + "") as string[];
      console.log("state cats Custs:", stateInfo);

      setSelectedState(() => stateInfo);
      setInitStates(() => stateInfo);
      // validateStates(stateInfo, true);
    }

    console.log("@@State Reeeeloaded:", states);
    //eslint-disable-next-line
  }, [states]);
  // console.log("@@selectedCustomer2:", selectedCustomer);

  useEffect(() => {
    // toggleDrawer(props.dockAt, props.show);
    if (selectedCustomer && selectedCustomer !== null) {
      getBrandingHistory()
      console.log("@@selectedCustomer:", selectedCustomer);
      selectedCustomer && setCustomer(selectedCustomer);
      console.log("customeredit", customer);
      console.log("formIk1", formik.values);

      const _cust = {
        customerId:
          selectedCustomer && selectedCustomer.customerId
            ? selectedCustomer.customerId
            : 0,
        trackNowLicenseId:
          selectedCustomer && selectedCustomer.trackNowLicenseId
            ? selectedCustomer.trackNowLicenseId
            : 0,
        postAwardLicenseId:
          selectedCustomer && selectedCustomer.postAwardLicenseId
            ? selectedCustomer.postAwardLicenseId
            : 0,
        customerName:
          selectedCustomer && selectedCustomer.customerName
            ? selectedCustomer.customerName
            : "",
        address:
          selectedCustomer && selectedCustomer.address
            ? selectedCustomer.address
            : undefined,
        city:
          selectedCustomer && selectedCustomer.city
            ? selectedCustomer.city
            : undefined,

        programName:
          selectedCustomer && selectedCustomer.programName
            ? selectedCustomer.programName
            : undefined,

        state:
          selectedCustomer && selectedCustomer.state
            ? selectedCustomer.state
            : undefined,

        zipCode:
          selectedCustomer && selectedCustomer.zipCode
            ? selectedCustomer.zipCode
            : null,
        taxNumber:
          selectedCustomer && selectedCustomer.taxNumber
            ? selectedCustomer.taxNumber
            : undefined,
        phone:
          selectedCustomer && selectedCustomer.phone
            ? selectedCustomer.phone
            : undefined,
        email:
          selectedCustomer && selectedCustomer.email
            ? selectedCustomer.email
            : undefined,
        notes:
          selectedCustomer && selectedCustomer.notes
            ? selectedCustomer.notes
            : undefined,
        customer_POC:
          selectedCustomer && selectedCustomer.customer_POC
            ? selectedCustomer.customer_POC
            : undefined,
        jsI_POC:
          selectedCustomer && selectedCustomer.tracknowJSIPOC
            ? selectedCustomer.tracknowJSIPOC
            : undefined,
        postAward_JsI_POC:
          selectedCustomer && selectedCustomer.postawardJSIPOC
            ? selectedCustomer.postawardJSIPOC
            : undefined,
        businessCatergoryId: 0,
        stateId: 0,
        parentCustomerId:
          selectedCustomer &&
            selectedCustomer.parentCustomer &&
            selectedCustomer.parentCustomer.customerId
            ? selectedCustomer.parentCustomer.customerId
            : 0,
        childCustomerId:
          selectedCustomer &&
            selectedCustomer.childCustomerId &&
            selectedCustomer.childCustomerId
            ? selectedCustomer.childCustomerId
            : null,
      };

      // if (
      // selectedCustomer?.businessCategory &&
      // selectedCustomer?.businessCategory.length > 0
      // ) {
      // const custBusinessCatergory = selectedCustomer?.businessCategory.map(
      // (item) => item.businessCategoryId + ""
      // ) as string[];
      // console.log("Business cats Custs:", custBusinessCatergory);
      // setSelectedCategories(custBusinessCatergory);
      // }
      selectedCustomer && formik.setValues(_cust);
      console.log("formil.setValues:", formik.values, "cust:", _cust);

      setFormTitle("EDIT CLIENT PROFILE");
      setActionLabel("Save");
      console.log("Parent Custs:", selectedCustomer?.parentCustomer);
      if (selectedCustomer?.parentCustomer) {
        const label = selectedCustomer?.parentCustomer.customerName
          ? selectedCustomer?.parentCustomer.customerName
          : "";
        const customerId = selectedCustomer?.parentCustomer.customerId
          ? selectedCustomer?.parentCustomer.customerId
          : 0;
        setClientType("Child");
        setInitParentClient({ label, customerId });
        setInitParentName(label);
        console.log("UF INT label", label, "customerId", customerId);

      }
      if (selectedCustomer?.childCustomer) {
        const label = selectedCustomer?.childCustomer.customerName
          ? selectedCustomer?.childCustomer.customerName
          : "";
        const customerId = selectedCustomer?.childCustomer.customerId
          ? selectedCustomer?.childCustomer.customerId
          : 0;
        setClientType("SubChild");
        setInitChildClient({ label, customerId });
        setInitChildName(label);
        console.log("UF INT label", label, "customerId", customerId);

      }
    }

    fetchBusinessCategories();
    fetchProgramName();
    fetchCustomers();

    // if (
    // categories &&
    // selectedCustomer?.businessCategory &&
    // selectedCustomer?.businessCategory.length > 0
    // ) {
    // const custBusinessCatergory = selectedCustomer?.businessCategory.map(
    // (item) => item.businessCategoryId + ""
    // ) as string[];
    // console.log("Business cats Custs:", custBusinessCatergory);
    // setSelectedCategories(() => custBusinessCatergory);
    // }

    return () => {
      if (setCurrentCustomer) setCurrentCustomer(null);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!selectedCustomer && isOnlyHierarchyAdmin) {
      if (hasParentInRoleDetails) {
        setClientType("Child");
      } else if (hasChildInRoleDetails || hasSubChildInRoleDetails) {
        setClientType("SubChild");
      }
    }
  }, [
    selectedCustomer,
    isOnlyHierarchyAdmin,
    hasParentInRoleDetails,
    hasChildInRoleDetails,
    hasSubChildInRoleDetails,
  ]);

  useEffect(() => {
    console.log(
      "UF clientType",
      clientType,
      "initParentClient",
      initParentClient,
      "initParentName",
      initParentName
    );
    if (clientType === "Parent") {

      setParentClient(null);
      setSelectedParentName("")
    }
    // Parent Client
    if (initParentClient && initParentName) {
      console.log("Setting Parent:", initParentClient);
      setParentClient(initParentClient);
      setSelectedParentName(initParentName);

    } else {
      console.log("Clearing Parent");
      setParentClient(null);
      setSelectedParentName("");
    }

    // Child Client
    if (initChildClient && initChildName) {
      console.log("Setting Child:", initChildClient);
      setChildClient(initChildClient);
      setSelectedChildName(initChildName);
    } else {
      console.log("Clearing Child");
      setChildClient(null);
      setSelectedChildName("");
    }

    if (clientType === "SubChild") {
      fetchCustomers()
    }
    if (clientType === "Child") {
      fetchCustomers();
    }
    console.log("SELECTED Parent:", parentClient);
    console.log("SELECTED Parent Name:", selectedParentName);
    console.log("SELECTED Child:", childClient);
    console.log("SELECTED Child Name:", selectedChildName);

    // eslint-disable-next-line
  }, [clientType]);

  useEffect(() => {
    if (Boolean(selectedCustomer?.customerId)) {
      console.log("ParentCheck selectedCustomer", selectedCustomer?.customerId, Boolean(selectedCustomer?.customerId));
      const filtAdminRole = roleDetails?.filter(item => item?.customerId === selectedCustomer?.customerId)
      console.log("ParentCheck filtAdminRole", filtAdminRole);
      const isAdminParentEdit = (roleType.includes("Admin") || roleType.includes("Admin-PostAward")) ? true : [
        "Admin-PostAward",
        "ClientAdmin",
        "ClientAdmin-PostAward",
        "HierarchyAdmin",
        "HierarchyAdmin-PostAward"].includes(filtAdminRole?.[0]?.roleName)
      console.log("ParentCheck isAdminParentEdit", isAdminParentEdit);
      setIsAdminParentEdit(isAdminParentEdit)
    }
  }, [selectedCustomer])

  const closeAlert = () => {
    const subscriptionValidationMessages = [
      "please select either tracknow subscription or post award subscription",
      "please select tracknow subscription",
      "please select post award subscription",
    ];
    const isSubscriptionValidationAlert =
      typeof alertMessage === "string" &&
      subscriptionValidationMessages.some((message) =>
        alertMessage.toLowerCase().includes(message)
      );

    setShowAlert(false);
    if (!isSubscriptionValidationAlert) {
      navigate("/");
    }
  };

  const validateCategories = (values: any, isDirect?: boolean) => {
    let error: any = {};

    const hasTrackNowLicense =
      formik.values.trackNowLicenseId !== null &&
      formik.values.trackNowLicenseId !== undefined &&
      formik.values.trackNowLicenseId !== "" &&
      formik.values.trackNowLicenseId !== 0;

    console.log(
      "catchanges",
      isCategoryChanged,
      selectedCustomer,
      isDirect,
      formik.values.trackNowLicenseId,
      hasTrackNowLicense
    );

    if (!hasTrackNowLicense) {
      setCategoriesErrorText("");
      return error;
    }

    if (isCategoryChanged || selectedCustomer || isDirect) {
      if (isDirect) {
        if (values.length <= 0) {
          setCategoriesErrorText("Federal Business Category is required");
          error.businessCategoryId = "please select a category";
        } else {
          setCategoriesErrorText("");
        }
      } else {
        if (selectedCategories.length <= 0) {
          setCategoriesErrorText("Federal Business Category is required");
          error.businessCategoryId = "please select a category";
        } else {
          setCategoriesErrorText("");
        }
      }
    }
    return error;
  };

  const validateProgramNames = (values: any, isDirect?: boolean) => {
    let error: any = {};

    console.log(
      "catchanges",
      isProgramsChanged,
      selectedCustomer,
      isDirect,
      formik.values.postAwardLicenseId
    );

    if (
      formik.values.postAwardLicenseId &&
      formik.values.postAwardLicenseId !== ""
    ) {
      if (isProgramsChanged || selectedCustomer || isDirect) {
        if (isDirect) {
          if (values.length <= 0) {
            setProgramsErrorText("Program Name is required");
            error.programId = "please select a program Name";
          } else {
            setProgramsErrorText("");
          }
        } else {
          if (selectedPrograms.length <= 0) {
            setProgramsErrorText("Program Name is required");
            error.programId = "please select a program Name";
          } else {
            setProgramsErrorText("");
          }
        }
      }
    }
    return error;
  };

  const validateStates = (values: any, isDirect?: boolean) => {
    let error: any = {};
    if (isStateChanged || selectedCustomer || isDirect) {
      if (isDirect) {
        if (values.length <= 0) {
          setStateErrorText("State is required");
          error.stateId = "please select a state";
        } else {
          setStateErrorText("");
        }
      } else {
        if (selectedState.length <= 0) {
          setStateErrorText("State is required");
          error.stateId = "please select a state";
        } else {
          setStateErrorText("");
        }
      }
    }
    return error;
  };

  const validateParentChildSelection = () => {
    let errors: any = {};
    let parentError = "";
    let childError = "";

    if (clientType !== "Parent") {
      if (!parentClient || !parentClient.customerId) {
        parentError = "Parent Client is required";
        errors.parentCustomerId = parentError;
      }
    }

    if (clientType === "SubChild") {
      if (!childClient || !childClient.customerId) {
        childError = "Child Client is required";
        errors.childCustomerId = childError;
      }
    }

    setParentClientError(parentError);
    setChildClientError(childError);

    return errors;
  };

  // };

  // const formik = useFormik({
  //   initialValues: initForm,
  //   validationSchema: validationSchema,
  //   validate: validateCategories,
  //   onSubmit: (values) => {
  //     submitForm();
  //   },
  // });

  const formik = useFormik({
    initialValues: initForm,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const parentChildErrors = validateParentChildSelection();
      const errors = {
        ...validateCategories(values),
        ...parentChildErrors,
        // ...validateProgramNames(values),
        // ...validateStates(values),
      };

      if (Object.keys(errors).length === 0) {
        submitForm();
      }
      setSubmitting(false);
    },
  });
  useEffect(() => {
    if (formik.values.notes) {
      const charsUsed = formik.values.notes.length;
      setRemainingChars(2000 - charsUsed);
    }
  }, [formik.values.notes]);
  useEffect(() => {
    console.log("selectedCustomer", selectedCustomer);

    if (selectedCustomer) {
      const custState = selectedCustomer.customerState;

      if (custState) {
        let stateEdit = custState.map((state: any) => ({
          stateId: state.stateId,
          customerId: state.customerId,
          state: state.state,
        }));
        formik.setFieldValue("customerState", stateEdit);
        const stateList = custState.map((item) => item.state);
        const convertedStateList = stateList as never[];
        setStateList(convertedStateList);
        console.log("convertedStateList", convertedStateList);
        console.log("stateEdit", stateEdit);
        console.log("FormIk", formik.values);
      } else {
        formik.setFieldValue("customerState", []);
        setStateList([]);
      }
    }
  }, [selectedCustomer]);
  useEffect(() => {
    if (formik.values.customerState) {
      console.log("custstate", formik.values.customerState);
      console.log("selCust", selectedCustomer?.customerState);
    }
  }, [formik.values.customerState]);
  useEffect(() => {
    console.log("formik.values", formik.values);
    console.log("selectedCustomer", selectedCustomer);
    console.log("selectedCategories initcat", selectedCategories, initCategories);
    console.log("selectedPrograms initialProgramNames", selectedPrograms, initialProgramNames);

    // Clear Program Names if Post Award Subscription is None or empty
    if (formik.values.postAwardLicenseId === 0 || formik.values.postAwardLicenseId === "") {
      setSelectedPrograms([]);
      setInitialProgramNames([]);
    }

    // Clear Federal Business Categories if TrackNow Subscription is None or empty
    if (formik.values.trackNowLicenseId === 0 || formik.values.trackNowLicenseId === "") {
      setSelectedCategories([]);
      setInitCategories([]);
      setCategoriesErrorText("");
    }
  }, [formik.values.trackNowLicenseId, formik.values.postAwardLicenseId])

  useEffect(() => {
    const hasTrackNowLicense =
      formik.values.trackNowLicenseId !== null &&
      formik.values.trackNowLicenseId !== undefined &&
      formik.values.trackNowLicenseId !== "" &&
      formik.values.trackNowLicenseId !== 0;

    if (!hasTrackNowLicense) {
      setCategoriesErrorText("");
    }
  }, [formik.values.trackNowLicenseId]);
  // useEffect(() => {
  //   console.log("zipCode", formik.values.zipCode);
  //   let zipcode = formik.values.zipCode ? parseInt(formik.values.zipCode) : 0;
  //   let findState = states.filter((s) => s.min <= zipcode && s.max >= zipcode);
  //   console.log("zipCode findState", findState);
  //   formik.values.state = findState.length > 0 ? [findState[0].code] : [];
  // }, [formik.values.zipCode]);
  // useEffect(() => {
  //   console.log("zipCode", formik.values.zipCode);
  //   let zipcode = formik.values.zipCode ? parseInt(formik.values.zipCode) : 0;
  //   let findState = states.filter((s) => s.min <= zipcode && s.max >= zipcode);
  //   console.log("zipCode findState", findState);
  //   formik.setFieldValue(
  //     "customerState",
  //     findState.length > 0 ? [findState[0].code] : []
  //   );
  //   console.log("fieldValue", formik.values.customerState);
  // }, [formik.values.zipCode]);

  // const schema = yup.object().shape({
  //   notes: yup
  //     .string()
  //     .max(250, "Maximum 250 characters allowed")
  //     .required("Notes is required"),
  // });
  useEffect(() => {
    console.log("BC selectedCategories", selectedCategories);
    console.log("BC initCategories", initCategories);
    console.log("BC selectedPrograms", selectedPrograms);
    console.log("BC initialProgramName", initialProgramNames);

  }, [selectedCategories, initCategories, selectedPrograms, initialProgramNames])
  const handleParentChange = (
    event: any,
    newValue: IClient | null,
    reason: string
  ) => {
    console.log("SELECTED Parent:", newValue);
    setChildClient(null);
    setParentClient(() => newValue);
    setSelectedParentName(newValue?.label ? newValue?.label : "");
    setParentClientError("");
    setChildClientError("");

    // setOpenParent(false);
    // setValue(newValue);
    setOpenOption(false);
  };
  const handleChildChange = (
    event: any,
    newValue: IClient | null,
    reason: string
  ) => {
    console.log("SELECTED Child:", newValue);
    setChildClient(() => newValue);
    setSelectedChildName(newValue?.label ? newValue?.label : "");
    setChildClientError("");

    // setOpenParent(false);
    // setValue(newValue);
    setOpenOption(false);
  };

  const handleTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    // if (value === "Parent") {
    // console.log("SELECTED Parent type:", value);
    // setParentClient(() => undefined);
    // }
    console.log("handleTypeChange value", value);

    setClientType(value);
    setParentClient(null);
    setSelectedParentName("");
    setChildClient(null);
    setSelectedChildName("");
    setParentClientError("");
    setChildClientError("");
  };

  function setOpen(arg0: boolean): void {
    throw new Error("Function not implemented.");
  }
  const handleSubmitCustom = (
    e?: React.FormEvent<HTMLFormElement> | undefined
  ) => {
    if (isSubChildRadioDisabled) {
      return;
    }
    console.log("@@@ Before Submit:");
    setIsCategoryChanged(true);
    setIsProgramsChanged(true);
    setIsStateChanged(true);
    // validateStates(selectedState, true);
    // validateProgramNames(selectedPrograms, true);
    validateCategories(selectedCategories, true);
    const parentChildErrors = validateParentChildSelection();

    if (Object.keys(parentChildErrors).length > 0) {
      return;
    }

    formik.handleSubmit(e);
  };

  return (
    <>
      {/* {showAlert && (
  <Alert message={alertMessage?.message} type={alertMessage?.type} />
  )} */}
      {/* <Toast ref={toast} />
  <ConfirmDialog /> */}
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={closeAlert}
        footer={null}
      >
        {alertMessage}
      </CustomDialog>
      <CssBaseline />

      <Box sx={{ flexGrow: 1 }}>
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          sx={{
            px: { xs: 2, md: 4 },
            width: "100%",
          }}
        >
          {!isLoading && isSubChildRadioDisabled && (
            <Container
              component="main"
              maxWidth="xl"
              sx={{
                px: { xs: 1.5, sm: 2, md: 3 },
                width: "100%",
              }}
            >
              <Alert style={{ fontSize: "small" }} severity="warning">
                Sub child does not have access to create/edit client
              </Alert>
            </Container>
          )}
          {!isLoading && openSnack !== "" && (
            <Container
              component="main"
              maxWidth="xl"
              sx={{
                px: { xs: 1.5, sm: 2, md: 3 },
                width: "100%",
              }}
            >
              <Alert style={{ fontSize: "small" }} severity="warning">
                {openSnack}
              </Alert>
            </Container>
          )}
          <Container
            component="main"
            maxWidth="xl"
            sx={{
              mb: 4,
              px: { xs: 1.5, sm: 2, md: 3 },
              width: "100%",
            }}
          >
            {isLoading ? (
              <Loader />
            ) : (
              <Box
                sx={{
                  backgroundColor: tokens.colors.offWhite,
                  borderRadius: "8px",
                  mt: 2,
                  padding: "2rem",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                <React.Fragment>
                  <form onSubmit={handleSubmitCustom} noValidate>
                    <Grid
                      container
                      spacing={3}
                      alignItems="center"
                    >
                      {/* Client Type — full row so it never overlaps the dropdowns */}
                      <Grid xs={12}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                        >
                          <Typography sx={{ ...fontStyle, whiteSpace: "nowrap" }}>
                            Client Type:
                          </Typography>

                          <RadioGroup
                            row
                            value={clientType}
                            onChange={handleTypeChange}
                          >
                            <FormControlLabel
                              value="Parent"
                              control={<TrackNowRadio />}
                              label="Parent"
                              disabled={selectedCustomer !== null || isParentRadioDisabled}
                            />

                            <FormControlLabel
                              value="Child"
                              control={<TrackNowRadio />}
                              label="Child"
                              disabled={selectedCustomer !== null || isChildRadioDisabled}
                            />

                            <FormControlLabel
                              value="SubChild"
                              control={<TrackNowRadio />}
                              label="SubChild"
                              disabled={selectedCustomer !== null || isSubChildRadioDisabled}
                            />
                          </RadioGroup>
                        </Stack>
                      </Grid>

                      {/* Parent Client dropdown — Grid itself only renders for Child / SubChild */}
                      {clientType !== "Parent" && (
                        <Grid xs={12} md={4}>
                          <TrackNowSelect
                            id="parentCustomerId"
                            label="Select Parent Client"
                            fullWidth
                            displayEmpty
                            required={clientType !== "Parent"}
                            helperText={parentClientError}
                            error={Boolean(parentClientError)}
                            renderValue={(selected) => {
                              if (!selected) {
                                return isLoadingParentDropdown ? "Loading..." : "Choose Parent Client";
                              }

                              const client = parentClientsList.find(
                                (c) => Number(c.customerId) === Number(selected)
                              );

                              return client?.label || (client as any)?.customerName || (client as any)?.name || "";
                            }}
                            disabled={isSubChildRadioDisabled || clientType === "Parent" || selectedCustomer !== null}
                            value={parentClient?.customerId ? String(parentClient.customerId) : ""}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedClient = parentClientsList.find(
                                (client) => Number(client.customerId) === Number(selectedId)
                              );
                              handleParentChange(null, selectedClient || null, "selectOption");
                            }}
                          >
                            <MenuItem value="" disabled style={{ display: "none" }}>
                              {isLoadingParentDropdown ? "Loading..." : "Choose Parent Client"}
                            </MenuItem>

                            {parentClientsList.map((client: any) => (
                              <MenuItem key={client.customerId} value={client.customerId}>
                                {client.label || client.customerName || client.name}
                              </MenuItem>
                            ))}
                          </TrackNowSelect>
                        </Grid>
                      )}

                      {/* Child Client dropdown — Grid itself only renders for SubChild */}
                      {clientType === "SubChild" && (
                        <Grid xs={12} md={4}>
                          <TrackNowSelect
                            id="childCustomerId"
                            label="Select Child Client"
                            fullWidth
                            required={clientType === "SubChild"}
                            displayEmpty
                            helperText={childClientError}
                            error={Boolean(childClientError)}
                            disabled={
                              isSubChildRadioDisabled || clientType !== "SubChild" || !parentClient?.customerId || selectedCustomer !== null
                            }
                            value={childClient?.customerId ? String(childClient.customerId) : ""}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedClient = childClientsList.find(
                                (client) => Number(client.customerId) === Number(selectedId)
                              );
                              handleChildChange(null, selectedClient || null, "selectOption");
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return isLoadingChildList
                                  ? "Loading..."
                                  : childClientsList.length === 0 && parentClient?.customerId
                                    ? "No child available for this parent company"
                                    : "Choose Child Client";
                              }

                              const client = childClientsList.find(
                                (c) => Number(c.customerId) === Number(selected)
                              );

                              return client?.label || (client as any)?.customerName || (client as any)?.name || "";
                            }}
                          >
                            <MenuItem value="" disabled style={{ display: "none" }}>
                              {isLoadingChildList
                                ? "Loading..."
                                : childClientsList.length === 0 && parentClient?.customerId
                                  ? "No child available for this parent company"
                                  : "Choose Child Client"}
                            </MenuItem>

                            {childClientsList.map((client: any) => (
                              <MenuItem key={client.customerId} value={client.customerId}>
                                {client.label || client.customerName || client.name}
                              </MenuItem>
                            ))}
                          </TrackNowSelect>
                        </Grid>
                      )}


                    </Grid>
                    <Grid container spacing={3} sx={{ mt: 3 }}>
                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          required
                          id="customerName"
                          name="customerName"
                          label="Client Name"
                          placeholder="Enter Client Name"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          autoComplete="CustomerName"
                          value={formik.values.customerName}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.customerName &&
                            Boolean(formik.errors.customerName)
                          }
                          helperText={
                            formik.touched.customerName &&
                            formik.errors.customerName
                          }
                        />
                      </Grid>

                      {hasTrackNowSubscriptionAccess ? (
                        <Grid xs={12} md={4}>
                          <TrackNowSelect
                            id="trackNowLicenseId"
                            name="trackNowLicenseId"
                            label="TrackNow Subscription"
                            fullWidth
                            displayEmpty
                            disabled={isSubChildRadioDisabled}
                            value={
                              formik.values.trackNowLicenseId
                                ? String(formik.values.trackNowLicenseId)
                                : ""
                            }
                            onChange={formik.handleChange}
                          >
                            <MenuItem value="" disabled style={{ display: 'none' }}>Select Subscription</MenuItem>
                            {licenseTypes.map((type) => (
                              <MenuItem
                                key={type.TrackNowLicenseId}
                                value={type.TrackNowLicenseId}
                              >
                                {type.TrackNowLicenseName}
                              </MenuItem>
                            ))}
                          </TrackNowSelect>
                        </Grid>
                      ) : null}

                      {hasPostAwardSubscriptionAccess ? (
                        <Grid xs={12} md={4}>
                          <TrackNowSelect
                            id="postAwardLicenseId"
                            name="postAwardLicenseId"
                            label="Post Award Subscription"
                            fullWidth
                            displayEmpty
                            disabled={isSubChildRadioDisabled}
                            value={
                              formik.values.postAwardLicenseId
                                ? String(formik.values.postAwardLicenseId)
                                : ""
                            }
                            onChange={formik.handleChange}
                          >
                            <MenuItem value="" disabled style={{ display: 'none' }}>Select Subscription</MenuItem>
                            {postAwardLicenseTypes.map((type) => (
                              <MenuItem
                                key={type.PostAwardLicenseId}
                                value={type.PostAwardLicenseId}
                              >
                                {type.PostAwardLicenseName}
                              </MenuItem>
                            ))}
                          </TrackNowSelect>
                        </Grid>
                      ) : null}
                      {hasTrackNowSubscriptionAccess ? (
                        <Grid xs={12} md={4}>
                          <MultiSelect
                            isdisabled={isSubChildRadioDisabled || !formik.values.trackNowLicenseId}
                            label="Federal Business Category"
                            inputs={categories.map((item) => ({
                              name: item.businessCategoryName
                                ? item.businessCategoryName
                                : "",
                              value: item.businessCategoryId
                                ? item.businessCategoryId + ""
                                : "",
                            }))}
                            values={selectedCategories}
                            initValues={initCategories}
                            updateSelection={handleCategoryChanges}
                            helperText={categoriesErrorText}
                          />
                        </Grid>) : null}
                      {hasPostAwardSubscriptionAccess ? (
                        <Grid xs={12} md={4}>
                          <MultiSelect
                            isdisabled={isSubChildRadioDisabled || !formik.values.postAwardLicenseId}
                            label="Program Name"
                            inputs={programOptions.map((item) => ({
                              name: item.programName ? item.programName : "",
                              value: item.programId ? item.programId + "" : "",
                            }))}
                            values={selectedPrograms}
                            initValues={initialProgramNames}
                            updateSelection={handleProgramNameChanges}
                            helperText={programsErrorText}
                          />
                        </Grid>) : null}

                      < Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="taxNumber"
                          name="taxNumber"
                          label="Tax Number"
                          placeholder="Enter Tax Number"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          autoComplete="TaxNumber"
                          value={formik.values.taxNumber}
                          inputProps={{
                            maxLength: 18,
                            inputMode: "numeric",
                          }}
                          onChange={formik.handleChange}
                        />
                      </Grid>
                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="phone"
                          name="phone"
                          label="Phone Number"
                          placeholder="Enter Phone Number"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          autoComplete="tel"
                          value={formik.values.phone}
                          onChange={(e) => {
                            const digits = e.target.value.replace(/\D/g, "").slice(0, 10);

                            let formatted = digits;

                            if (digits.length > 6) {
                              formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
                            } else if (digits.length > 3) {
                              formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
                            } else if (digits.length > 0) {
                              formatted = `(${digits}`;
                            }

                            formik.setFieldValue("phone", formatted);
                          }}
                          inputProps={{
                            maxLength: 14, // (123) 456-7890
                            inputMode: "numeric",
                          }}
                          error={formik.touched.phone && Boolean(formik.errors.phone)}
                          helperText={formik.touched.phone && formik.errors.phone}
                        />
                      </Grid>
                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="email"
                          name="email"
                          label="Email"
                          placeholder="Enter Client Email"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          autoComplete="customer-email"
                          value={formik.values.email}
                          onChange={(e) => {
                            formik.setFieldValue("email", e.target.value.toLowerCase());
                          }}
                          inputProps={{
                            maxLength: 30,
                          }}
                          error={
                            formik.touched.email && Boolean(formik.errors.email)
                          }
                          helperText={formik.touched.email && formik.errors.email}
                        />
                      </Grid>
                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="customer_POC"
                          name="customer_POC"
                          label="Client Contact"
                          placeholder="Enter Client Contact"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          value={formik.values.customer_POC}
                          inputProps={{
                            maxLength: 12,
                          }}
                          onChange={formik.handleChange}
                        />
                      </Grid>

                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          disabled
                          id="TrackNow_jsI_POC"
                          name="TrackNow_jsI_POC"
                          label="TrackNow JSI POC Email"
                          placeholder="Auto-assigned based on configuration"
                          fullWidth
                          value={formik.values.jsI_POC}
                          onChange={formik.handleChange}
                        />
                      </Grid>

                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          disabled
                          id="PostAward_jsI_POC"
                          name="PostAward_jsI_POC"
                          label="PostAward JSI POC Email"
                          placeholder="Auto-assigned based on configuration"
                          fullWidth
                          value={formik.values.postAward_JsI_POC}
                          onChange={formik.handleChange}
                        />
                      </Grid>

                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="address"
                          name="address"
                          label="Address"
                          placeholder="Enter Address"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          inputProps={{
                            maxLength: 200,
                            inputMode: "numeric",
                          }}
                          autoComplete="shipping address"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                        />
                      </Grid>
                      <Grid xs={12} md={4}>
                        <MultiSelect
                          isdisabled={isSubChildRadioDisabled}
                          label="State"
                          inputs={states.map((item) => ({
                            name: item.state ? item.state : "",
                            value: item.code ? item.code + "" : "",
                          }))}
                          values={selectedState}
                          initValues={initStates}
                          updateSelection={handleStateChanges}
                          helperText={stateErrorText}
                        />
                      </Grid>

                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="zipCode"
                          name="zipCode"
                          label="Zip / Postal Code"
                          placeholder="Enter Zip / Postal Code"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          autoComplete="shipping postal-code"
                          value={formatZipCode(formik.values.zipCode)}
                          onChange={(e) => {
                            const digits = e.target.value.replace(/\D/g, "").slice(0, 9);

                            formik.setFieldValue(
                              "zipCode",
                              digits ? Number(digits) : null
                            );
                          }}
                          inputProps={{
                            maxLength: 10, // 12345-6789
                            inputMode: "numeric",
                          }}
                          onBlur={formik.handleBlur}
                          error={formik.touched.zipCode && Boolean(formik.errors.zipCode)}
                          helperText={formik.touched.zipCode && formik.errors.zipCode}
                        />
                      </Grid>
                      <Grid xs={12} md={4}>
                        <TrackNowTextField
                          id="city"
                          name="city"
                          label="City"
                          placeholder="Enter City"
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          autoComplete="shipping address-city"
                          value={formik.values.city}
                          inputProps={{
                            maxLength: 20,
                          }}
                          onChange={formik.handleChange}
                        />
                      </Grid>

                      {/* Branding Configuration for Parent Clients */}
                      {clientType === "Parent" && isBrandingRoleIncludes && (!selectedCustomer?.customerId || isAdminParentEdit) && (
                        <Grid xs={12}>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 2.5,
                              borderRadius: "12px",
                              border: `1px solid ${tokens.colors.midGrey}`,
                              backgroundColor: "#ffffff",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                              mt: 1,
                            }}
                          >
                            <Stack
                              direction={{ xs: "column", sm: "row" }}
                              justifyContent="space-between"
                              alignItems={{ xs: "flex-start", sm: "center" }}
                              spacing={2}
                            >
                              <Stack direction="row" spacing={2} alignItems="center">
                                <Box
                                  sx={{
                                    width: 44,
                                    height: 44,
                                    borderRadius: "10px",
                                    backgroundColor: `${brandingConfig.primaryColor || tokens.colors.connectedPurple}18`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: brandingConfig.primaryColor || tokens.colors.connectedPurple,
                                  }}
                                >
                                  <PaletteOutlinedIcon sx={{ fontSize: 24 }} />
                                </Box>
                                <Box>
                                  <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography sx={{ fontWeight: 700, fontSize: "16px", color: tokens.colors.offBlack }}>
                                      Branding Configuration
                                    </Typography>
                                    {isBrandingCustomized ? (
                                      <Chip
                                        label="Custom Theme Configured"
                                        size="small"
                                        color="success"
                                        variant="outlined"
                                        sx={{ fontWeight: 600, fontSize: "11px" }}
                                      />
                                    ) : (
                                      <Chip
                                        label="Default Theme"
                                        size="small"
                                        variant="outlined"
                                        sx={{ fontWeight: 500, fontSize: "11px", color: tokens.colors.grey }}
                                      />
                                    )}
                                  </Stack>
                                  <Typography sx={{ fontSize: "13px", color: tokens.colors.grey, mt: 0.5 }}>
                                    Customize portal colors, font family, and logo for this Parent client and its hierarchy.
                                  </Typography>
                                </Box>
                              </Stack>

                              <Stack direction="row" spacing={2} alignItems="center">
                                <Stack direction="row" spacing={1} alignItems="center">
                                  <Box
                                    title={`Primary Color: ${brandingConfig.primaryColor}`}
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      borderRadius: "6px",
                                      backgroundColor: brandingConfig.primaryColor || "#001a77",
                                      border: "1px solid rgba(0,0,0,0.1)",
                                    }}
                                  />
                                  <Box
                                    title={`Background Color: ${brandingConfig.backgroundColor}`}
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      borderRadius: "6px",
                                      backgroundColor: brandingConfig.backgroundColor || tokens.colors.offWhite,
                                      border: "1px solid rgba(0,0,0,0.1)",
                                    }}
                                  />
                                  <Chip
                                    label={brandingConfig.fontFamily || "Roboto"}
                                    size="small"
                                    sx={{ fontSize: "12px", height: 26, backgroundColor: tokens.colors.offWhite }}
                                  />
                                </Stack>

                                {showResetButton && (
                                  <TrackNowButton
                                    variant="tertiary"
                                    disabled={isSubChildRadioDisabled}
                                    onClick={handleResetBranding}
                                  >
                                    Reset Branding
                                  </TrackNowButton>
                                )}

                                <TrackNowButton
                                  variant="secondary"
                                  disabled={isSubChildRadioDisabled}
                                  onClick={() => setOpenBrandingModal(true)}
                                >
                                  {Boolean(selectedCustomer?.customerId) && hasExistingBranding
                                    ? "Manage Branding"
                                    : "Configure Branding"}
                                </TrackNowButton>
                              </Stack>
                            </Stack>
                          </Paper>
                        </Grid>
                      )}

                      <Grid xs={12}>
                        <TrackNowTextField
                          id="notes"
                          name="notes"
                          label="Notes"
                          placeholder="Enter Additional Notes (Max 2000 Characters)"
                          multiline
                          fullWidth
                          disabled={isSubChildRadioDisabled}
                          minRows={3}
                          value={formik.values.notes}
                          onChange={(e) => {
                            if (e.target.value.length <= 2000) {
                              formik.handleChange(e);
                              setRemainingChars(2000 - e.target.value.length);
                            }
                          }}
                        />

                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: "small",
                            color: remainingChars === 0 ? "red" : "inherit",
                            display: remainingChars === 2000 ? "none" : "block",
                          }}
                        >
                          {remainingChars} Characters are left
                        </Typography>
                      </Grid>
                      <Grid
                        xs={12}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <TrackNowButton
                          variant="tertiary"
                          onClick={backToHome}
                        >
                          Cancel
                        </TrackNowButton>
                        <TrackNowButton
                          variant="primary"
                          disabled={isSubChildRadioDisabled}
                          onClick={handleSubmitCustom}
                        >
                          {actionLabel}
                        </TrackNowButton>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Box>
            )}
            {openBrandingModal && (
              <CustomerBrandingModal
                open={openBrandingModal}
                onClose={() => setOpenBrandingModal(false)}
                customerId={selectedCustomer?.customerId || customer?.customerId || null}
                customerName={formik.values.customerName || selectedCustomer?.customerName || ""}
                brandingConfig={brandingConfig}
                setBrandingConfig={setBrandingConfig}
                pendingBrandingAction={pendingBrandingActionRef.current || pendingBrandingAction}
                onBrandingSaved={handleBrandingSaved}
              />
            )}
          </Container>
        </Stack>
      </Box>
    </>
  );
}
